export { default, styleFunction } from './Box';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Box/index.js
// module id = 810
// module chunks = 2